export default "__VITE_ASSET__LjyGT$H4__"